<template>
  <div class="container">
    <app-header title="搜索商品" />
    <van-search v-model="value"
                @search="_getByShopProduct"
                placeholder="搜索商品名称" />
    <div class="recommend-content">
      <Goods :productList="productList"/>
    </div>
    <div style="margin-top: 50px;text-align: center;"
         v-if="!productList.length">
      暂无商品
    </div>
  </div>
</template>

<script>
import Goods from './Goods'
import { getByShopProduct } from '@/api/product/index.js'
export default {
  name: 'Index',
  components: {
    Goods
  },
  data () {
    return {
      value: '',
      productList: [],
      title: ''
    }
  },
  created () {
    console.log(this.$route)
    this.title = this.$route.query.name
    this.value = this.$route.query.name
    this._getByShopProduct()
  },
  methods: {
    _getByShopProduct () {
      const params = {
        name: this.value
      }
      getByShopProduct(params).then((res) => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    onNavigate (item) {
      this.$router.push({
        path: 'product/detail',
        query: { id: item.pid }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .recommend-content {
    padding: 10px 12px;
    background: #ffffff;
    .item {
      border: 1px solid rgba(243, 243, 243, 1);
      .name {
        height: 38px;
        font-size: 14px;
        font-weight: bold;
        line-height: 17px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }
      .footer {
        display: flex;
        justify-content: space-between;
        .price {
          height: 30px;
          font-size: 16px;
          font-weight: bold;
          line-height: 30px;
          color: rgba(254, 0, 59, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/modules/search_product.vue